module.exports = __webpack_public_path__ + "img/AGTEALCROPPED.223b556a.png";